import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import AnalogModal from '../../../../../../components/AnalogModal';
import { getFromLocalStorage } from '../../../../../../global/helpers';

interface ProductsTableRowProps {
  data: any;
  product: any;
  dateInput: string;
  setDateInput: (value: React.SetStateAction<string>) => void;
  updateProductFieldById?: (id: string, field: string, value: any) => void;
  handleCloseAnalogModal: () => void;
  handleOpenAnalogModal: () => void;
  isAnalogModalOpen: boolean;
  source: string;
  orderId: string;
  notFilled:
    | {
        sku: string;
        term: boolean;
        price: boolean;
        diff: boolean;
        analog: boolean;
      }
    | undefined;
}

const EditCheckboxContainer = ({
  data,
  product,
  dateInput,
  setDateInput,
  updateProductFieldById,
  handleCloseAnalogModal,
  handleOpenAnalogModal,
  isAnalogModalOpen,
  source,
  orderId,
  notFilled,
}: ProductsTableRowProps) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const userRole = getFromLocalStorage('role');
  const [analogCheckbox, setAnalogCheckbox] = useState<boolean>(false);
  const [analogCheckboxOnOrder, setAnalogCheckboxOnOrder] = useState<{
    on_fact: boolean;
    on_order: boolean;
  }>({ on_fact: false, on_order: false });

  const handleCloseModalAnalogs = () => {
    handleCloseAnalogModal && handleCloseAnalogModal();
    setAnalogCheckbox(false);
  };
  useEffect(() => {
    setAnalogCheckbox(!!product.proposal);
  }, [product.proposal]);

  return (
    <>
      <div className="checkbox-container">
        <div className="form-container">
          <div className="container-table">
            <div className="flex-container">
              <div className="cell">
                <input
                  id="term"
                  name="term"
                  type="checkbox"
                  disabled={false}
                  checked={
                    data?.item?.term?.is_term ? data.item.term.is_term : false
                  }
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    updateProductFieldById &&
                      updateProductFieldById(
                        product.sku,
                        'item.term.is_term',
                        isChecked
                      );
                  }}
                />
                Сроковый
              </div>

              {data?.item?.term?.is_term && (
                <div className="cell">
                  <input
                    id="termDate"
                    name="termDate"
                    type="text"
                    disabled={false}
                    placeholder="10.2001"
                    className="input-data"
                    style={
                      notFilled?.term ? { border: '3px solid #ff4c4c' } : {}
                    }
                    value={dateInput}
                    onChange={(e) => {
                      let value = e.target.value.replace(/\D/g, '');
                      value = value.slice(0, 6);
                      if (value.length >= 2) {
                        value =
                          // eslint-disable-next-line
                          value.slice(0, 2) + '.' + value.slice(2);
                      }
                      setDateInput(value);
                      updateProductFieldById &&
                        updateProductFieldById(
                          product.sku,
                          'item.term.exp_date',
                          value
                        );
                    }}
                    onKeyDown={(e) => {
                      const inputElement = e.target as HTMLInputElement;
                      if (
                        !(
                          e.key === 'Backspace' ||
                          e.key === 'Delete' ||
                          e.key === '.'
                        )
                      ) {
                        // eslint-disable-next-line
                        if (isNaN(parseInt(e.key))) {
                          e.preventDefault();
                        }
                      } else if (
                        e.key === 'Backspace' &&
                        inputElement.selectionStart ===
                          inputElement.selectionEnd &&
                        inputElement.selectionStart === 3
                      ) {
                        // eslint-disable-next-line
                        let value = inputElement.value;
                        value = value.slice(0, 2) + value.slice(3);
                        inputElement.value = value;
                        setDateInput(value);
                        e.preventDefault();
                      }
                    }}
                  />
                </div>
              )}
              {data?.item?.term?.is_term && (
                <div className="cell">
                  Предложить Аналог{' '}
                  <input
                    id="term"
                    name="term"
                    type="checkbox"
                    disabled={false}
                    checked={analogCheckbox}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setAnalogCheckbox(isChecked);
                      isChecked && handleOpenAnalogModal();
                    }}
                  />
                </div>
              )}
            </div>
            <div className="flex-container">
              <div className="cell">
                <input
                  id="notAvailable"
                  name="notAvailable"
                  type="checkbox"
                  disabled={false}
                  checked={
                    data?.item?.out_of_stock?.is_out_of_stock
                      ? data.item.out_of_stock.is_out_of_stock
                      : false
                  }
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    isChecked && handleOpenAnalogModal();
                    updateProductFieldById &&
                      updateProductFieldById(
                        product.sku,
                        'item.out_of_stock.is_out_of_stock',
                        isChecked
                      );
                  }}
                />
                Нет в наличии
              </div>
              {data?.item?.out_of_stock?.is_out_of_stock && (
                <>
                  <div className="cell">
                    По факту
                    <input
                      id="term"
                      name="term"
                      type="checkbox"
                      disabled={false}
                      checked={data?.item?.out_of_stock?.in_fact}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        updateProductFieldById &&
                          updateProductFieldById(
                            product.sku,
                            'item.out_of_stock.in_fact',
                            isChecked
                          );
                        // isChecked && handleOpenAnalogModal();
                      }}
                    />
                  </div>
                  <div className="cell">
                    По базе
                    <input
                      id="term"
                      name="term"
                      type="checkbox"
                      disabled={false}
                      checked={data?.item?.out_of_stock?.in_database}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        updateProductFieldById &&
                          updateProductFieldById(
                            product.sku,
                            'item.out_of_stock.in_database',
                            isChecked
                          );
                        // isChecked && handleOpenAnalogModal();
                      }}
                    />
                  </div>
                  <div className="cell">
                    Предложить Аналог{' '}
                    <input
                      id="term"
                      name="term"
                      type="checkbox"
                      disabled={false}
                      checked={analogCheckbox}
                      onChange={(e) => {
                        const isChecked = e.target.checked;
                        setAnalogCheckbox(isChecked);
                        isChecked && handleOpenAnalogModal();
                      }}
                    />
                  </div>
                </>
              )}
            </div>

            <div className="flex-container">
              <div className="cell">
                <input
                  id="differentPrice"
                  name="differentPrice"
                  type="checkbox"
                  disabled={false}
                  checked={
                    data?.item?.other_price?.is_other_price
                      ? data.item.other_price.is_other_price
                      : false
                  }
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    updateProductFieldById &&
                      updateProductFieldById(
                        product.sku,
                        'item.other_price.is_other_price',
                        isChecked
                      );
                  }}
                />
                Другая цена по базе
              </div>
              {data?.item?.other_price?.is_other_price && (
                <div className="cell">
                  Ваша цена
                  <input
                    id="yourPrice"
                    name="yourPrice"
                    type="text"
                    disabled={false}
                    className="input"
                    style={
                      notFilled?.price ? { border: '3px solid #ff4c4c' } : {}
                    }
                    onChange={(e) => {
                      const isChecked = e.target.value;
                      updateProductFieldById &&
                        updateProductFieldById(
                          product.sku,
                          'item.other_price.price',
                          isChecked
                        );
                    }}
                  />
                </div>
              )}
            </div>

            <div className="flex-container">
              <div className="cell">
                <input
                  id="differentPack"
                  name="differentPack"
                  type="checkbox"
                  disabled={false}
                  checked={
                    data?.item?.packing_diff?.is_packing_diff
                      ? data.item.packing_diff.is_packing_diff
                      : false
                  }
                  onChange={(e) => {
                    const isChecked = e.target.checked;
                    updateProductFieldById &&
                      updateProductFieldById(
                        product.sku,
                        'item.packing_diff.is_packing_diff',
                        isChecked
                      );
                  }}
                />
                Есть разница в упаковке, в виде
              </div>

              {data?.item?.packing_diff?.is_packing_diff && (
                <div className="cell">
                  <input
                    id="differentPackDescription"
                    name="differentPackDescription"
                    type="text"
                    placeholder="комментарий"
                    disabled={false}
                    className="input-accent"
                    style={
                      notFilled?.diff ? { border: '3px solid #ff4c4c' } : {}
                    }
                    onChange={(e) => {
                      const isChecked = e.target.value;
                      updateProductFieldById &&
                        updateProductFieldById(
                          product.sku,
                          'item.packing_diff.diff',
                          isChecked
                        );
                    }}
                  />
                </div>
              )}
            </div>
            <div className="cell">
              <input
                id="needRecipe"
                name="needRecipe"
                type="checkbox"
                disabled={false}
                checked={
                  data?.item?.need_receipt ? data.item.need_receipt : false
                }
                onChange={(e) => {
                  const isChecked = e.target.checked;
                  updateProductFieldById &&
                    updateProductFieldById(
                      product.sku,
                      'item.need_receipt',
                      isChecked
                    );
                }}
              />
              Нужен рецепт
            </div>
          </div>
        </div>
      </div>
      {isAnalogModalOpen && (
        <AnalogModal
          onClose={handleCloseModalAnalogs}
          source={source}
          orderId={orderId}
        />
      )}
    </>
  );
};

export default EditCheckboxContainer;
